import React, { useState } from 'react';
import { Play, Plus, ChevronDown } from 'lucide-react';

const ProjectCard = ({ project, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative flex-shrink-0 w-72 cursor-pointer transition-all duration-300 ease-in-out group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onClick(project)}
    >
      <div className={`relative overflow-hidden rounded-lg transition-transform duration-300 ${
        isHovered ? 'scale-110 z-10' : 'scale-100'
      }`}>
        <div className="relative aspect-video bg-gray-800">
          <img
            src={project.image}
            alt={project.company}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
          
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="text-white font-semibold text-lg">{project.company}</h3>
            <p className="text-gray-300 text-sm">{project.role}</p>
          </div>
        </div>

        {isHovered && (
          <div className="absolute inset-0 bg-[#181818] top-full group-hover:top-0 transition-all duration-300 rounded-lg shadow-2xl">
            <div className="relative aspect-video">
              <img
                src={project.image}
                alt={project.company}
                className="w-full h-full object-cover rounded-t-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#181818] via-transparent to-transparent" />
            </div>

            <div className="p-4 space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex space-x-2">
                  <button className="w-8 h-8 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition">
                    <Play size={16} fill="black" className="text-black ml-0.5" />
                  </button>
                  <button className="w-8 h-8 border-2 border-gray-400 rounded-full flex items-center justify-center hover:border-white transition">
                    <Plus size={16} className="text-white" />
                  </button>
                </div>
                <button className="w-8 h-8 border-2 border-gray-400 rounded-full flex items-center justify-center hover:border-white transition">
                  <ChevronDown size={16} className="text-white" />
                </button>
              </div>

              <div className="space-y-2">
                <h3 className="text-white font-semibold text-base">{project.company}</h3>
                <p className="text-green-400 text-xs font-semibold">{project.duration}</p>
                <p className="text-gray-400 text-sm line-clamp-2">{project.description}</p>
              </div>

              <div className="flex flex-wrap gap-1">
                {project.technologies.slice(0, 4).map((tech, index) => (
                  <span
                    key={index}
                    className="px-2 py-0.5 bg-gray-700 text-white text-xs rounded"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;